import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { VERIFF_CODES } from '@/helpers/constants';
import { userService } from '../../services/userService';

export const useGetVeriffStatus = options => {
  return useQuery({
    ...options,
    staleTime: data => {
      if (data.state.data?.code === VERIFF_CODES.verified) return Infinity;
      return 1000 * 3;
    },
    refetchOnWindowFocus: true,
    refetchInterval: data => {
      if (!data) return false; // stop polling if no data
      if (data.state.data?.code === VERIFF_CODES.submitted) {
        return 1000; // start polling if Veriff has been submitted
      }
      return false;
    },
    queryKey: [QUERY_KEYS.user.veriff_status],
    queryFn: () =>
      userService.veriffStatus().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
